import { Resource } from "./resource";
import { ReferenceDataItem } from "./referenceDataItem";
import { NamedResource } from "./namedResource";
import { Form } from "./form";
export class MachineDeploymentPreview extends Resource {
    HasLatestCalamari: boolean;
    Name: string;
}

export class DeploymentTemplateStep {
    ActionId: string;
    ActionName: string;
    ActionNumber: string;
    Roles: string[];
    Machines: MachineDeploymentPreview[];
    CanBeSkipped: boolean;
    IsDisabled: boolean;
    HasNoApplicableMachines: boolean;
    UnavailableMachines: ReferenceDataItem[];
    ExcludedMachines: ReferenceDataItem[];
}

export class DeploymentPreviewResource extends Resource {
    StepsToExecute: DeploymentTemplateStep[];
    Form: Form;
    UseGuidedFailureModeByDefault: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/deploymentPreviewResource.ts